module.exports = __webpack_public_path__ + "img/section_bg3.96aea4fe.png";